<template>
	<el-dialog title="分数" width="30%" center :visible="show" @close="close" :close-on-click-modal="false">
		<el-input type="textarea" :rows="2" placeholder="请输入分数" :autosize="{ minRows: 4, maxRows: 99 }" v-model="exerciseBook"></el-input>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props:{
		show:null,
		p:String,
		v:String,
		branch:String
	},
	data() {
		return {
			exerciseBook:'',
		};
	},
	mounted() {
	},
	methods: {
		close() {
			this.$emit('closes', false);
		},
		goButton(){
			if(!this.exerciseBook){
				this.$message.error("评分不能为空！")
				return
			}
			if(parseInt(this.exerciseBook) > parseInt(this.branch)){
				this.$message.error("分值不能超过此题满分！")
				return
			}
			this.$request.ajax(this).post("/api_teacher/homework_correcting",{
					job_record_id:this.p,
					student_id:this.v,
					score:this.exerciseBook,
					result:1 //1.正确，2.错误
				}).then(res=>{
					// console.log(res)
					this.$message({
						type: 'success',
						message: res.msg
					});
					this.$emit('goButton', false,1,this.exerciseBook);
				})
			// console.log(this.exerciseBook)
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/homet/correct/commponents/topicUp.vue